export default __webpack_public_path__ + "043ad3559c6669348fec89966d80dee0.png";